import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';
import { Table,   Space } from 'antd';
import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';   
import { CSVLink, CSVDownload } from "react-csv";
import ReactExport from "react-export-excel";
import { api, URL } from '../../api';
import Modelreportfacultylist from './Modelreportfacultylist';
import Modelreportfacultylistterm from './Modelreportfacultylistterm';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
  import { Bar } from 'react-chartjs-2';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );


//const ExcelFile = ReactExport.ExcelFile;
//const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
//const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//import Button from '@material-ui/core/Button';  
    
////import React, { useRef } from "react"

export default class Reportnumfaculty extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          modal: false,
          type:'1',
          reportnum:'',
          Fa01:'',
          Fa02:'',
          Fa03:'',
          Fa04:'',
          Fa05:'',
          Fa06:'',
          Fa08:'',
          term:'',
          term2:'',

          Fa01sent:'01',
          Fa02sent:'02',
          Fa03sent:'03',
          Fa04sent:'04',
          Fa05sent:'05',
          Fa06sent:'06',
          Fa08sent:'08',
        
      
        };
       
        this.refreshPage = this.refreshPage.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.getteam = this.getteam.bind(this);
        
     
      }


      onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
      }


      resetdata= e =>{
      console.log(e.target.value);
        // const idemp = value;
         this.setState({ major:'' });
     }



      refreshPage() {
         window.location.reload(false);
       }


          componentDidMount(){
           
            if (localStorage.getItem('name') == null) {
               
                  window.location.href = 'https://e-student.kpru.ac.th/creditbank'
               
            } else {
        
            }
         //   api.get('index/getteacheruniv/'+localStorage.getItem('Univ_ID'),
              Axios.get(`https://mua.kpru.ac.th/FrontEnd_creditbank/administator/reportnumfaculty`,
            //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                    {headers: {
                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                    }
                    })
                    //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                    .then(res => {
                    // console.log(res.data[0].id)
                    //  console.log(res.data)
                    //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                    //  console.log(Course)
                        const reportnum = res.data;
                        this.setState({ reportnum ,
                            Fa01 : res.data[0].Fa01,
                            Fa02 : res.data[0].Fa02,
                            Fa03 : res.data[0].Fa03,
                            Fa04 : res.data[0].Fa04,
                            Fa05 : res.data[0].Fa05,
                            Fa06 : res.data[0].Fa06,
                            Fa08 : res.data[0].Fa08,
                        });
                    }) 
          }


          getteam() {
            setTimeout(() => {
               //ภายใน
                Axios.get('https://mua.kpru.ac.th/FrontEnd_creditbank/administator/reportnumfacultyteam/'+this.state.term)
               .then(res => {
              //   console.log(res);
               //  this.setState({ bankname: res.data, loading: false })

               const reportnum = res.data;
               this.setState({ reportnum ,
                   Fa01 : res.data[0].Fa01,
                   Fa02 : res.data[0].Fa02,
                   Fa03 : res.data[0].Fa03,
                   Fa04 : res.data[0].Fa04,
                   Fa05 : res.data[0].Fa05,
                   Fa06 : res.data[0].Fa06,
                   Fa08 : res.data[0].Fa08,
                   term2 : this.state.term,
               });


               }) 
             }, 0);
          }


      
    render() {

      //  console.log(this.state.Showteather)
     const options = {
        responsive: true,
        plugins: {
          legend: {
            position: 'top' ,
          },
          title: {
            display: true,
            text: 'จำนวนหลักสูตรแต่ละคณะ',
          },
        },
      };
      
      const labels = ['คณะวิทยาศาสตร์และเทคโนโลยี', 'คณะครุศาสตร์', 'คณะมนุษศาสตร์และสังคมศาสตร์', 'คณะวิทยาการจัดการ', 'คณะเทคโนโลยีอุตสาหกรรม', 'มหาวิทยาลัยราชภัฏกำแพงเพชร แม่สอด', 'คณะพยาบาลศาสตร์'];
      const data = {
        labels,
        datasets: [
          {
            label: 'จำนวนหลักสูตร',
            data: [this.state.Fa01,this.state.Fa02,this.state.Fa03,this.state.Fa04,this.state.Fa05,this.state.Fa06,this.state.Fa08],
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
          }
        //   ,
        //   {
        //     label: 'Dataset 2',
        //     data: [20,30,65,32,25,50,50],
        //     backgroundColor: 'rgba(53, 162, 235, 0.5)',
        //   },
        ],
      };
    
        return (
            <MDBContainer fluid>
              
    
        {/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
       <Card type="inner" style={{ marginTop: 16 }}  title={<h4><MDBIcon icon="list-alt" /> จำนวนหลักสูตรแต่ละคณะ</h4> } extra={<a href="#"><p>คุณ{localStorage.getItem('name')}</p></a>} >
      
                <div className="form-group">
                <label htmlFor="example2"><MDBIcon icon="search" /> ค้นหาภาคเรียน เช่น 1/2566</label><br/>
                <Input placeholder="ภาคเรียน"  style={{ width: 300 }} value={this.state.term} name="term" onChange={this.onTextChange} required  /><Button type="primary" onClick={this.getteam}>ค้นหา</Button>
                   {/* <input type="text" id="example2"  placeholder="ชื่อ" className="form-control form-control-md" value={this.state.Studentcb_NAME} name="Studentcb_NAME" onChange={this.onTextChange} required /> */}
                </div>
        <MDBJumbotron className="p-4" >
        <h2 className="display-5 deep-purple-text text-center"> {this.state.term ===''?<>รายงานจำนวนหลักสูตรแต่ละคณะ</>:<>รายงานจำนวนหลักสูตรแต่ละคณะ ภาคเรียนที่ {this.state.term}</>} </h2>
                  <MDBRow>
                  {/* <Modelupdatetecher/>   */}
              
                          <MDBCol sm="12">
                           
                            <MDBTable striped>
                                <MDBTableHead>
                                    <tr>
                                    <th>#</th>
                                    <th>คณะ</th>
                                    <th>จำนวนหลักสูตร</th>
                                    <th>ข้อมูล</th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    <tr>
                                    <td>1</td>
                                    <td>คณะวิทยาศาสตร์และเทคโนโลยี</td>
                                    <td> {this.state.Fa01}</td>
                                    <td>{this.state.term2 ==='' ?<><Modelreportfacultylist faculty = {this.state.Fa01sent}/> </>:<><Modelreportfacultylistterm faculty = {this.state.Fa01sent} term={this.state.term2} /></>}
                                     </td>
                                    </tr>
                                    <tr>
                                    <td>2</td>
                                    <td>คณะครุศาสตร์</td>
                                    <td> {this.state.Fa02}</td>
                                    <td>{this.state.term2 ==='' ?<><Modelreportfacultylist faculty = {this.state.Fa02sent}/> </>:<><Modelreportfacultylistterm faculty = {this.state.Fa02sent} term={this.state.term2} /></>}</td>
                                    </tr>
                                    <tr>
                                    <td>3</td>
                                    <td>คณะมนุษศาสตร์และสังคมศาสตร์</td>
                                    <td> {this.state.Fa03}</td>
                                    <td>{this.state.term2 ==='' ?<><Modelreportfacultylist faculty = {this.state.Fa03sent}/> </>:<><Modelreportfacultylistterm faculty = {this.state.Fa03sent} term={this.state.term2} /></>}</td>
                                    </tr>
                                    <tr>
                                    <td>4</td>
                                    <td>คณะวิทยาการจัดการ</td>
                                    <td> {this.state.Fa04}</td>
                                    <td>{this.state.term2 ==='' ?<><Modelreportfacultylist faculty = {this.state.Fa04sent}/> </>:<><Modelreportfacultylistterm faculty = {this.state.Fa04sent} term={this.state.term2} /></>}</td>
                                    </tr>
                                    <tr>
                                    <td>5</td>
                                    <td>คณะเทคโนโลยีอุตสาหกรรม</td>
                                    <td> {this.state.Fa05}</td>
                                    <td>{this.state.term2 ==='' ?<><Modelreportfacultylist faculty = {this.state.Fa05sent}/> </>:<><Modelreportfacultylistterm faculty = {this.state.Fa05sent} term={this.state.term2} /></>}</td>
                                    </tr>
                                    <tr>
                                    <td>6</td>
                                    <td>มหาวิทยาลัยราชภัฏกำแพงเพชร แม่สอด</td>
                                    <td> {this.state.Fa06}</td>
                                    <td>{this.state.term2 ==='' ?<><Modelreportfacultylist faculty = {this.state.Fa06sent}/> </>:<><Modelreportfacultylistterm faculty = {this.state.Fa06sent} term={this.state.term2} /></>}</td>
                                    </tr>
                                    <tr>
                                    <td>7</td>
                                    <td>คณะพยาบาลศาสตร์</td>
                                    <td> {this.state.Fa08}</td>
                                    <td>{this.state.term2 ==='' ?<><Modelreportfacultylist faculty = {this.state.Fa08sent}/> </>:<><Modelreportfacultylistterm faculty = {this.state.Fa08sent} term={this.state.term2} /></>}</td>
                                    </tr>
          
                                </MDBTableBody>
                            </MDBTable>
                            <br/> 
                         
                          </MDBCol>
                
                </MDBRow>
                <p>หมายเหตุ : จำนวนที่แสดงผ่านการอนุมัติจากหลักสูตรแล้ว</p>
        </MDBJumbotron>
        <MDBJumbotron className="p-4" >
        {/* <h2 className="display-5 deep-purple-text text-center">กราฟ</h2> */}

        <Bar options={options} data={data} />
        </MDBJumbotron>
        </Card>

       
            </MDBContainer>
        )
    }
}
